import {Pipe, PipeTransform} from '@angular/core';
import {Solutions} from '../../domain/core/model/solutions';
import {PortfolioSolutionsEnum} from '../../domain/core/model/portfolio-solutions.enum';

@Pipe({
        name: 'applicationName'
      })
export class ApplicationNamePipe implements PipeTransform {

  static readonly dette = 'Dette';
  static readonly detteGarantie = 'Dette garantie';
  static readonly prospective = 'Prospective';
  static readonly detteAndProspective = 'Dette et Prospective';
  static readonly fiscalite = 'Fiscalité';
  static readonly portail = 'Portail';
  static readonly appelOffre = 'Appel d\'offres';
  static readonly journalDesOffres = 'Journal des Offres';
  static readonly observatory = 'Observatoire';
  static readonly subsidies = 'Aides & subventions';
  static readonly dashboard = 'Tableau de bord';

  transform(value: any, args?: any): any {
    switch (value.toString().toLowerCase()) {
      case Solutions.insito:
        return ApplicationNamePipe.dette;
      case Solutions.inviseo:
        return ApplicationNamePipe.prospective;
      case Solutions.fiscalite:
        return ApplicationNamePipe.fiscalite;
      case Solutions.alliance:
        return ApplicationNamePipe.detteGarantie;
      case Solutions.insito_sante:
        return ApplicationNamePipe.dette;
      case Solutions.insito_habitat:
        return ApplicationNamePipe.dette;
      case Solutions.portal:
        return ApplicationNamePipe.portail;
      case Solutions.funding_tender:
        return ApplicationNamePipe.appelOffre;
      case Solutions.bank_proposal_dashboard:
        return ApplicationNamePipe.journalDesOffres;
      case Solutions.observatory:
        return ApplicationNamePipe.observatory;
      case Solutions.dashboard:
        return ApplicationNamePipe.dashboard;
      case Solutions.subsidies:
        return ApplicationNamePipe.subsidies;
      case Solutions.dette:
        return ApplicationNamePipe.dette;
      case Solutions.prospective:
        return ApplicationNamePipe.prospective;
      case Solutions.detteEtProspective:
        return ApplicationNamePipe.detteAndProspective;
      case Solutions.apollo:
        return ApplicationNamePipe.dette;
      default:
        return value;
    }
  }
}
